'use strict';

export const setCookie = (name, value, hoursOrOptions, cookieOptions) => {
    let expires = '';
    let options = cookieOptions || {};
    let hours = hoursOrOptions;

    if (typeof hoursOrOptions === 'object' && hoursOrOptions !== null) {
        options = hoursOrOptions;
        hours = options.hours;
    }

    if (hours) {
        const date = new Date();
        date.setTime(date.getTime() + hours * 60 * 60 * 1000);
        expires = `; expires=${date.toUTCString()}`;
    }

    let cookie = `${name}=${value || ''}${expires}; path=${options.path || '/'}`;

    if (options.domain) {
        cookie += `; domain=${options.domain}`;
    }

    if (options.sameSite) {
        cookie += `; SameSite=${options.sameSite}`;
    }

    if (options.secure) {
        cookie += '; Secure';
    }

    document.cookie = cookie;
};

export const getCookie = (name) => {
    const nameEQ = `${name}=`;
    const ca = document.cookie.split(';');

    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];

        while (c.charAt(0) === ' ') {
            c = c.substring(1, c.length);
        }

        if (c.indexOf(nameEQ) === 0) {
            return c.substring(nameEQ.length, c.length);
        }
    }

    return null;
};

export default {
    setCookie: setCookie,
    getCookie: getCookie
};